import { IAppSetting } from '@addins/core/core';
import { BehaviorSubject, Observable } from 'rxjs';

export class AppSetting<T> implements IAppSetting<T> {
  protected readonly _value: BehaviorSubject<T>;

  get $change(): Observable<T> {
    return this._value.asObservable();
  }

  get current(): T {
    return this._value.value;
  }

  constructor(protected _name: string, _default: T, protected _useStorage: boolean) {
    this._value = new BehaviorSubject<T>(_default);
  }

  setValue(_value: T) {
    if (_value !== this.current && this._useStorage) {
      localStorage.setItem(this._name, `${_value}`);
    }
    if (_value !== this.current) {
      this._value.next(_value);
    }
  }
}
